import * as React from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

const emotionCache = createCache({
	key: 'settings-webmodules',
	nonce: EMOTION_NONCE,
	prepend: true,
});

export const EmotionCache = (props: { children: React.ReactNode }): JSX.Element => {
	return <CacheProvider value={emotionCache}>{props.children}</CacheProvider>;
};
